import { canNativeShare } from "@/utils/share";

export function buildModuleUrl(origin: string, path: string, moduleSlug: string): string {
  const cleanPath = path.split("?")[0];
  return `${origin}${cleanPath}?module=${moduleSlug}`;
}

// Results share message, aligned with the Cover Story game-over share.
export function buildResultShareText({
  title,
  score,
  total,
  shareText,
  url,
}: {
  title?: string | null;
  score?: number | null;
  total?: number | null;
  shareText?: string | null;
  url: string;
}): string {
  // Personality quizzes have no score, so the line is dropped rather than
  // rendered as "undefined/undefined". A real 0 must survive the check.
  const scoreLine = typeof score === "number" && typeof total === "number" ? `${score}/${total}` : null;
  return [title?.trim() || "Rock Hall Quiz", scoreLine, shareText?.trim() || null, url].filter(Boolean).join("\n");
}

async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(textarea);
      return ok;
    } catch {
      return false;
    }
  }
}

// Real mobile devices get the native OS share sheet;
export async function shareResult({
  text,
  onCopied,
}: {
  text: string;
  onCopied?: () => void;
}): Promise<"shared" | "copied" | "failed"> {
  if (canNativeShare()) {
    try {
      await navigator.share({ title: "Rock Hall Quiz", text });
      return "shared";
    } catch {
      return "failed";
    }
  }

  const copied = await copyToClipboard(text);
  if (copied) {
    onCopied?.();
    return "copied";
  }
  return "failed";
}
